import AssetUpload from './AssetUpload';
import AssetList from './AssetList';
import ModelAssetList from './ModelAssetList';
import { authRoles } from '../../../auth/auth';

export const AssetConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes  : [
        {
            path: '/asset-upload/',
            component: AssetUpload
        },
        {
            path: '/asset/list/',
            component: AssetList
        },
        {
            path: '/asset/last/:model_type/:model_id',
            component: ModelAssetList
        }
    ]
};



// WEBPACK FOOTER //
// src/main/content/asset/AssetConfig.js